import ReactApexChart from "react-apexcharts";
import { Card, CardBody, Col } from "reactstrap";
import { H4, LI, UL } from "../../../../../AbstractElements";
import { OurGoalOverviewTitle } from "../../../../../Constants/Constants";
import { GoalOverView } from "../../../../../Data/General/Dashboard/ECommerce";
import DashboardCommonHeader from "../../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";

const OurGoalOverview = () => {
  return (
    <Col xl="4" md="6">
      <Card className="goal-overview">
        <DashboardCommonHeader title={OurGoalOverviewTitle} dropdownClass="dropdown-toggle" />
        <CardBody>
          <div id="goal-rview">
            <ReactApexChart type="line" options={GoalOverView} series={GoalOverView.series} height={235} />
          </div>
          <UL className="goal-list simple-list flex-row">
            <LI>
              <H4>65%</H4>
              <span>Completed Goal</span>
            </LI>
            <LI>
              <H4>96%</H4>
              <span>Expected Goal</span>
            </LI>
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};

export default OurGoalOverview;
